import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'en-GB',
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
  weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  weekdaysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'dddd D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'DD/MM/YYYY',
    'l-Y': 'DD/MM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, h:mm A',
    'lll-Y': 'D MMM, h:mm A',
    llll: 'ddd, D MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D MMM, h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'am', PM: 'pm' },
  past: {
    y: { one: '%s yr ago', other: '%s yrs ago' },
    M: { one: '%s mo ago', other: '%s mo ago' },
    w: { one: '%s wk ago', other: '%s wks ago' },
    d: { one: '%s day ago', other: '%s days ago' },
    h: { one: '%s hr ago', other: '%s hrs ago' },
    m: { one: '%s min ago', other: '%s mins ago' },
    s: { one: '%s sec ago', other: '%s secs ago' },
  },
  future: {
    y: { one: 'in %s yr', other: 'in %s yrs' },
    M: { one: 'in %s mo', other: 'in %s mo' },
    w: { one: 'in %s wk', other: 'in %s wks' },
    d: { one: 'in %s day', other: 'in %s days' },
    h: { one: 'in %s hr', other: 'in %s hrs' },
    m: { one: 'in %s min', other: 'in %s mins' },
    s: { one: 'in %s sec', other: 'in %s secs' },
  },
  pastLong: {
    y: { one: '%s year ago', other: '%s years ago' },
    M: { one: '%s month ago', other: '%s months ago' },
    w: { one: '%s week ago', other: '%s weeks ago' },
    d: { one: '%s day ago', other: '%s days ago' },
    h: { one: '%s hour ago', other: '%s hours ago' },
    m: { one: '%s minute ago', other: '%s minutes ago' },
    s: { one: '%s second ago', other: '%s seconds ago' },
  },
  futureLong: {
    y: { one: 'in %s year', other: 'in %s years' },
    M: { one: 'in %s month', other: 'in %s months' },
    w: { one: 'in %s week', other: 'in %s weeks' },
    d: { one: 'in %s day', other: 'in %s days' },
    h: { one: 'in %s hour', other: 'in %s hours' },
    m: { one: 'in %s minute', other: 'in %s minutes' },
    s: { one: 'in %s second', other: 'in %s seconds' },
  },
  abbr: {
    y: { one: '%sy', other: '%sy' },
    M: { one: '%smo', other: '%smo' },
    w: { one: '%sw', other: '%sw' },
    d: { one: '%sd', other: '%sd' },
    h: { one: '%sh', other: '%sh' },
    m: { one: '%s min', other: '%s mins' },
    s: { one: '%ss', other: '%ss' },
  },
  full: {
    y: { one: '%s year', other: '%s years' },
    M: { one: '%s month', other: '%s months' },
    w: { one: '%s week', other: '%s weeks' },
    d: { one: '%s day', other: '%s days' },
    h: { one: '%s hour', other: '%s hours' },
    m: { one: '%s minute', other: '%s minutes' },
    s: { one: '%s second', other: '%s seconds' },
  },
  justNow: 'Now',
  yesterday: 'Yesterday',
  today: 'Today',
  tomorrow: 'Tomorrow',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd D MMM', end: 'ddd D MMM' },
    D: { start: 'ddd D MMM', end: 'ddd D MMM' },
    yt: { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm' },
    mt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    dt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'en-GB';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return `[${n}${s[(v - 20) % 10] || s[v] || s[0]}]`;
  },
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'am';
    } else {
      return isLowerCase ? 'pm' : 'pm';
    }
  },
};
